import { useMemo } from 'react';

import { CustomFieldAttribute, customFieldsApi } from 'apis/customFields';

/**
 * Loads the merged conversation + contact custom-field attributes as a single
 * flat list. Both queries are skipped together when `skip` is true.
 *
 * Shared by every consumer that needs the full set of attributes the user can
 * build expressions against.
 */
export const useMergedCustomFieldAttributes = ({
  skip = false,
}: { skip?: boolean } = {}): readonly CustomFieldAttribute[] => {
  const { data: conversationAttributesData } =
    customFieldsApi.useReadAttributesQuery(
      { entityId: 'conversation' },
      { skip },
    );
  const { data: contactAttributesData } =
    customFieldsApi.useReadAttributesQuery({ entityId: 'contact' }, { skip });

  return useMemo(
    () => [
      ...(conversationAttributesData?.data?.attributes ?? []),
      ...(contactAttributesData?.data?.attributes ?? []),
    ],
    [
      conversationAttributesData?.data?.attributes,
      contactAttributesData?.data?.attributes,
    ],
  );
};
